import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import logo from '../../assets/logo.svg'

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Grid from '@material-ui/core/Grid';

import HomeRightPane from './HomeRightPane'


import './header.css'

export default class Header extends Component {
  scrollToHeader() {
        window.scrollTo(0, 0);
    }
  render() {

    return (
     <AppBar className={css(styles.appBar)} position="static" color="default">
      <Grid className="container" container>
        <Toolbar className={css(styles.noPadding)}>
        <a style={{width: 'inherit'}} onClick={this.props.scrollToHeader}>
    	   <img onClick={this.scrollToHeader} className={css(styles.logo)} src={logo} alt=""/>
        </a>
          <Grid container alignItems="center" justify='flex-end'>
            <HomeRightPane />
          </Grid>
        </Toolbar>
      </Grid>
    </AppBar>
    );
  }
}
const styles = StyleSheet.create({
    appBar: {
      backgroundColor: 'rgba(73, 130, 235, 0.80)',
      boxShadow: 'none',
      position: 'fixed',
      width: '100%',
      top:'0', right: '0'
    },
    noPadding: {
      padding: '0',
      width: '100%'
    },
    logo: {
    	maxWidth: '170px',
    	padding: '.5em 0',
      cursor: 'pointer',
      ':hover': {
        opacity: .9
      }
    }
});


// WEBPACK FOOTER //
// ./src/Components/Header/Header.js